import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-10-naveen-munjal-guest.webp";
import ThumbImg from "../../assets/images/conversations/010.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: he-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .he-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .he-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .he-hero { padding-top: 60px; padding-bottom: 60px; }
  .he-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .he-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .he-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .he-hero__title.he-visible { opacity: 1; transform: translateY(0); }
  .he-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .he-hero__spotify.he-visible { opacity: 1; transform: translateY(0); }
  .he-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .he-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .he-hero__right.he-visible { opacity: 1; transform: translateY(0); }

  .he-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .he-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .he-yt-thumb:hover img { opacity: 0.85; }
  .he-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .he-yt-thumb__play img { width: 40px; height: 44px; }
  .he-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .he-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .he-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .he-body.he-visible { opacity: 1; transform: translateY(0); }
  .he-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .he-body__para:last-child { margin-bottom: 0; }

  .he-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .he-guest.he-visible { opacity: 1; transform: translateY(0); }
  .he-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .he-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .he-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .he-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .he-inner { padding-left: 32px; padding-right: 32px; }
    .he-hero { padding-top: 32px; padding-bottom: 48px; }
    .he-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .he-hero__title { font-size: 24px; }
    .he-hero__left { gap: 16px; }
    .he-guest__title { font-size: 24px; margin-bottom: 24px; }
    .he-guest__photo-bg { width: 260px; height: 300px; }
    .he-guest__name { font-size: 24px; margin-top: 18px; }
    .he-body__para { font-size: 14px; margin-bottom: 12px; }
    .he-body { padding-bottom: 48px; }
    .he-guest { padding-bottom: 48px; }
    .he-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .he-inner { padding-left: 16px; padding-right: 16px; }
    .he-hero { padding-top: 51px; padding-bottom: 30px; }
    .he-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .he-hero__left { gap: 30px; }
    .he-hero__title { font-size: 30px; }
    .he-body__para { font-size: 16px; margin-bottom: 10px; }
    .he-guest__title { font-size: 30px; margin-bottom: 20px; }
    .he-guest__photo-bg { width: 100%; height: 386px; }
    .he-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .he-body { padding-bottom: 30px; }
    .he-guest { padding-bottom: 30px; }
    .he-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("he-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "Bt7w3JOYdNk";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="he-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 10 Hero Electric"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="he-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 10 Hero Electric thumbnail" />
      <div className="he-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="he-hero">
      <div className="he-inner">
        <div className="he-hero__grid">
          <div className="he-hero__left">
            <h1 ref={titleRef} className="he-hero__title">
              EP 10 | The "HERO" Of EVs | Hero Electric Pvt Ltd
            </h1>
            <div ref={spotifyRef} className="he-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/0XGMHCOY91ItDPNs8iQskI?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 10 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="he-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="he-body">
      <div className="he-inner">
        <p className="he-body__para">
          Today we speak to one of the crucial lynchpins of the entire EV movement in India.
        </p>
        <p className="he-body__para">
          As an entrepreneur, he is widely recognized for his role in shaping the Indian Electric scooter industry and also for his contributions to various forums in the Electric Vehicles sector both in India and globally.
        </p>
        <p className="he-body__para">
          He completed his Master's in Business Administration from Huron University in London, and apprenticed with Land Rover in West Midlands, UK, before returning to India and becoming the first entrepreneur to introduce the electric vehicles to the country in 2001. His EV venture was already selling vehicles in 2007, before Tesla has even sold its first car commercially.
        </p>
        <p className="he-body__para">
          He has held various key positions in organizations such as the YPO or Young President's Organization and EO, Entrepreneurs Organisation and was previously also Chairman of the Confederation of Indian Industry's New Delhi State Council.
        </p>
        <p className="he-body__para">
          He is the Managing Director of Hero Electric. Naveen MUNJAL.
        </p>
        <p className="he-body__para">
          You sure don't want to miss this one!
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="he-guest">
      <div className="he-inner">
        <h2 className="he-guest__title">Our Guest</h2>
        <div>
          <div className="he-guest__photo-bg">
            <img src={GuestImg} alt="Naveen Munjal" />
          </div>
          <p className="he-guest__name">Naveen MUNJAL</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep10HeroElectric() {
  return (
    <>
      <style>{CSS}</style>
      <div className="he-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}